import React, {useEffect} from 'react';
import ParticipantInfo from '../../ParticipantInfo/videoRoom/ParticipantInfo';
import ParticipantTracks from '../../ParticipantTracks/ParticipantTracks';
import { LocalParticipant, RemoteParticipant } from 'twilio-video';
import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';
import { LocalAudioTrack } from 'twilio-video';

interface ParticipantProps {
  participant: LocalParticipant | RemoteParticipant;
  disableAudio?: boolean;
  enableScreenShare?: boolean;
  localParticipantFlag?: boolean;
  onClick: () => void;
  isSelected: boolean;
  currentUser: any;
  muteUnmuteParticipant: any;
  muteUnmuteAllParticipants: any;
  activeCalls: any;
  guestMobileNumber: any;
  self?:any;
  muteUnmuteSelf?:any
  
}








export default function Participant({
  participant,
  currentUser,
  disableAudio,
  enableScreenShare,
  localParticipantFlag,
  onClick,
  activeCalls,
  muteUnmuteParticipant,
  muteUnmuteAllParticipants,
  isSelected,
  self,
  muteUnmuteSelf,
  guestMobileNumber,
}: ParticipantProps) {

  const { room: {localParticipant},localTracks } = useVideoContext();
  const audioTrack = localTracks.find(track => track.kind === 'audio') as LocalAudioTrack;
  let data = window.localStorage.getItem('muteAudio')
  if (data && data !== null && data !== '' && data !== undefined && data != 'undefined') {

    let message = JSON.parse(data)

    if (message && message.participantIds && window.localStorage.getItem('user') && message.participantIds.includes(window.localStorage.getItem('user'))) {
      if (audioTrack && message.mute == false) {
        audioTrack.enable();
      }
      if (audioTrack && message.mute == true) {
        audioTrack.disable();
      }
    }

    if (message && message.participantIds && currentUser && message.participantIds.includes(currentUser)) {

      if (audioTrack && message.mute == false) {
        audioTrack.enable();
      }
      if (audioTrack && message.mute == true) {
        audioTrack.disable();
      }
    }
    window.localStorage.removeItem('muteAudio')
  }

  // participant.setMaxListeners(1)


  // participant.on('trackSubscribed', track => {
  //   if (track.kind === 'data') {
  //     track.on('message', (data: any) => {
        
  //       let message = JSON.parse(data)

  //       if(message && message.participantIds && window.localStorage.getItem('user') && message.participantIds.includes(window.localStorage.getItem('user'))){
  //         if(audioTrack && message.isMute == false){
  //           audioTrack.enable();
  //         } 
  //         if(audioTrack && message.isMute == true){
  //           audioTrack.disable();
  //         }
  //       }

  //       if(message && message.participantIds && currentUser && message.participantIds.includes(currentUser)){

  //         if(audioTrack && message.isMute == false){
  //           audioTrack.enable();
  //         } 
  //         if(audioTrack && message.isMute == true){
  //           audioTrack.disable();
  //         }
  //       }

  //     });
  //   }
  // });
  return (
    <div>
    <ParticipantInfo localParticipantFlag={localParticipantFlag ? true : false} 
    activeCalls={activeCalls} 
    participant={participant} 
    onClick={onClick} 
    self={self}
    muteUnmuteSelf={muteUnmuteSelf}
    muteUnmuteParticipant={muteUnmuteParticipant} 
    muteUnmuteAllParticipants={muteUnmuteAllParticipants}
    currentUser={currentUser} isSelected={isSelected}>
     <div className="video-thumbnail"> <ParticipantTracks participant={participant} disableAudio={disableAudio} enableScreenShare={enableScreenShare} />
     </div>
    </ParticipantInfo>
    </div>
  );
}
